import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

import { GlobalActionButtons } from "~/components/global-action-buttons";
import { TrackPageView } from "~/components/track-page-view";
import { getAuthStore } from "~/modules/auth/auth-store";
import { getCheckoutInfoQuery } from "~/modules/checkout/network/queries";
import { getStripeKeyMode } from "~/modules/checkout/utils";
import { ForceAcceptTermsDialog } from "~/modules/onboarding/components/terms-dialog";
import { css } from "~/styled-system/css";

export const Route = createFileRoute("/pay")({
  component: RouteComponent,
  async beforeLoad() {
    const profileResponse = await getAuthStore().ensureProfile();

    if (!profileResponse) {
      throw redirect({ to: "/", search: { redirectTo: "/pay" } });
    }

    if (profileResponse.currentOrg.subscription) {
      // if you are already subscribed, redirect to billing
      throw redirect({ to: "/settings/billing" });
    }

    return { user: profileResponse.user, org: profileResponse.currentOrg };
  },
  async loader({ context }) {
    await context.queryClient.ensureQueryData(
      getCheckoutInfoQuery.queryOptions({ params: { stripeKeyMode: getStripeKeyMode() } })
    );
  },
});

function RouteComponent() {
  return (
    <div className={layoutStyles}>
      <ForceAcceptTermsDialog />
      <TrackPageView />
      <GlobalActionButtons />
      <Outlet />
    </div>
  );
}

const layoutStyles = css({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  height: "100dvh",
  padding: "16px",
});
